'use strict';

const generateCartUrl = (optionuuid, dealuuid) => {
  return `/cart/add/${optionuuid}?deal_id=${dealuuid}`;
};

const getGoodsCartFormItems = (deal, displayOption, quantity = 1) => {
  return [
    {
      dealUuid: deal.uuid,
      uuid: displayOption.uuid,
      quantity: quantity,
    },
  ];
};

module.exports = { generateCartUrl, getGoodsCartFormItems };
